module.exports = __webpack_public_path__ + "icon-arrow-up-down-lake.0d4c520a4d1e4dfe55ee.svg";